module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-265.579f798.woff2";